import PageContainer from '@components/Layout/PageContainer/PageContainer';
import { IS_NATERA } from '@constants/constants';
import { DraftOrderDetailProvider } from '@contexts/useDraftOrderDetail';
import AccountReview from '@pages/account-review/AccountReview';
import DraftOrderDetail from '@pages/draftOrderDetail/DraftOrderDetail';
import DraftOrders from '@pages/draftOrders/DraftOrders';
import ErrorPage from '@pages/error/errorPage';
import Login from '@pages/login/login';
import NateraLogin from '@pages/login/nateraLogin';
import UserManagement from '@pages/manage-users/UserManagement';
import MyDelegates from '@pages/my-delegates/MyDelegates';
import { OrderMethylationReanalysis, OrderNewReport, OrderReanalysis, PatientDetail } from '@pages/patientDetail';
import RequisitionComplete from '@pages/requisitionComplete/RequisitionComplete';
import RequisitionCreate from '@pages/requisitionCreate/RequisitionCreate';
import ConsentsPublicPage from '@pages/consentsPublic/ConsentsPublicPage';
import SessionExpired from '@pages/session-expired/SessionExpired';
import Signup from '@pages/signup/Signup';
import { RequisitionsPage } from '../pages';
import { ROUTE_PATHS, RoutePath } from './paths';

export interface PageRoute {
  path: RoutePath;
  element: React.ReactNode;
  PageContainer?: ({ children }: { children: React.ReactNode }) => React.ReactElement;
  oldLayout?: boolean;
  private?: boolean; // True for protected routes
  onlyAuth?: boolean; // True for auth pages
}

const routes: PageRoute[] = [
  {
    path: ROUTE_PATHS.REQUISITION_LIST,
    element: <RequisitionsPage />,
    private: true,
  },
  {
    path: ROUTE_PATHS.REQUISITION_CREATE,
    element: <RequisitionCreate />,
    private: true,
  },
  {
    path: ROUTE_PATHS.REQUISITION_SUBMITTED,
    element: <RequisitionComplete />,
    private: true,
  },
  {
    path: ROUTE_PATHS.PATIENT_DETAILS,
    element: <PatientDetail />,
    PageContainer,
    private: true,
  },
  {
    path: ROUTE_PATHS.PATIENT_ORDER_NEW_REPORT,
    element: <OrderNewReport />,
    private: true,
  },
  {
    path: ROUTE_PATHS.PATIENT_ORDER_REANALYSIS,
    element: <OrderReanalysis />,
    private: true,
  },
  {
    path: ROUTE_PATHS.PATIENT_ORDER_METHYLATION_REANALYSIS,
    element: <OrderMethylationReanalysis />,
    private: true,
  },
  {
    path: ROUTE_PATHS.ROOT,
    element: IS_NATERA ? <NateraLogin /> : <Login />,
    oldLayout: !IS_NATERA, // Natera login does not use the old layout
  },
  {
    path: ROUTE_PATHS.LOGIN,
    element: IS_NATERA ? <NateraLogin /> : <Login />,
    onlyAuth: true,
    oldLayout: !IS_NATERA, // Natera login does not use the old layout
  },
  {
    path: ROUTE_PATHS.SIGNUP,
    element: <Signup />,
    onlyAuth: true,
  },
  {
    path: ROUTE_PATHS.ACCOUNT_REVIEW,
    element: <AccountReview />,
    onlyAuth: true,
  },
  {
    path: ROUTE_PATHS.MY_DELEGATES,
    element: <MyDelegates />,
    private: true,
  },
  {
    path: ROUTE_PATHS.MANAGE_USERS,
    element: <UserManagement />,
    private: true,
  },
  {
    path: ROUTE_PATHS.DRAFT_REQUISITION_LIST,
    element: <DraftOrders />,
    private: true,
  },
  {
    path: ROUTE_PATHS.DRAFT_REQUISITION_DETAILS,
    element: (
      <DraftOrderDetailProvider>
        <DraftOrderDetail />
      </DraftOrderDetailProvider>
    ),
    private: true,
  },
  {
    path: ROUTE_PATHS.ERROR,
    element: <ErrorPage />,
    oldLayout: true,
  },
  {
    path: ROUTE_PATHS.SESSION_EXPIRED,
    element: <SessionExpired />,
    oldLayout: true,
  },
  {
    path: ROUTE_PATHS.CONSENTS,
    element: <ConsentsPublicPage />,
    oldLayout: true,
  },
];

export default routes;
